import { Select, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useLogoutSupabase } from 'src/auth/hooks/use-logout-supabase';
import { routes } from 'src/constants/routes';
import { getStorage, removeStorage } from 'src/utils/local-storage-versioning';
import { useIsUserAuthenticated } from 'src/lib/hooks/use-is-user-authenticated';

import { styles } from './styles';

export const LogoutDropdown = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { data: userSession } = useIsUserAuthenticated();

    const userName = userSession?.user.user_metadata.preferredName
        ? userSession?.user.user_metadata.preferredName
        : userSession?.user.user_metadata?.firstName;

    const title = (
        <Typography variant="h4" css={styles.nameText}>
            {`${t('header_greeting')} ${userName}`}
        </Typography>
    );

    const handleLogoutSuccess = () => {
        const storage = getStorage();
        const { roomCode, academicYear, paymentPlanId, pid, cbl, rebooker } = storage.redirectState;

        if (roomCode && academicYear) {
            removeStorage();
            const params = [`roomCode=${roomCode}`, `academicYear=${academicYear}`];

            if (paymentPlanId) params.push(`paymentPlanId=${paymentPlanId}`);
            if (pid) params.push(`pid=${pid}`);
            if (cbl) params.push(`cbl=${cbl}`);
            if (rebooker) params.push(`rebooker=${rebooker}`);

            navigate(`${routes.summary.index}?${params.join('&')}`);
        }
    };

    const { mutate: logoutUser } = useLogoutSupabase(handleLogoutSuccess);

    const handleLogoutClick = () => {
        logoutUser();
    };

    return (
        <Select
            value={title}
            onChange={handleLogoutClick}
            variant="standard"
            disableUnderline
            IconComponent={() => null}
            renderValue={() => title}
            MenuProps={{
                sx: styles.menuList,
            }}
            css={styles.container}
        >
            <MenuItem css={styles.menuItem} onClick={handleLogoutClick}>
                <Typography variant="subtitle3">{t('header_logout')}</Typography>
            </MenuItem>
        </Select>
    );
};
